import React from 'react';
import {
  ProductInfo,
  ProductName,
  ProductNameAndSpecs,
  ProductPrice,
  ProductPriceAndQuantityContainer,
  ProductQuantity,
  ProductRow,
  ProductSpecs,
} from './styles';
import ProductImage from '../sharedComponents/ProductImage';
import { IProductImage } from '../models';
import { useAdminTranslation } from 'hooks/use-translation';

interface IProductSummaryItemProps {
  productAvailableForSale: boolean;
  productImages: IProductImage[];
  productName: string;
  productPrice: string;
  productQuantity: string;
  productSpecs: string;
}

const ProductSummaryItem: React.FC<IProductSummaryItemProps> = ({
  productAvailableForSale,
  productImages,
  productName,
  productSpecs,
  productPrice,
  productQuantity,
}) => {
  const { t } = useAdminTranslation();
  return (
    <ProductRow>
      {productImages.length && (
        <ProductImage images={productImages} source={'CartProduct'}  name={productName} isAvailableForSale={productAvailableForSale} />
      )}
      <ProductInfo>
        <ProductNameAndSpecs>
          <ProductName>{productName}</ProductName>
          <ProductSpecs>{productSpecs}</ProductSpecs>
        </ProductNameAndSpecs>
        <ProductPriceAndQuantityContainer>
          <ProductPrice>{`$${productPrice}`}</ProductPrice>
          <ProductQuantity>{`${t('QTY')} ${productQuantity}`}</ProductQuantity>
        </ProductPriceAndQuantityContainer>
      </ProductInfo>
    </ProductRow>
  );
};

export default ProductSummaryItem;
